import gql from 'graphql-tag';

export const attendanceTeamFragment = gql`
  fragment attendanceTeamParts on AttendanceTeam {
    id
    partnerPersonContextId
    name
    memberPersonContextIds
  }
`;
